"use client";

import { Copy, Check } from "lucide-react";
import { useState } from "react";

import { Button } from "@/lib/components/button";

import { useI18n } from "@llmgateway/i18n/react";

interface CopyModelNameProps {
	modelName: string;
	providerId?: string;
}

export function CopyModelName({ modelName, providerId }: CopyModelNameProps) {
	const { t } = useI18n();
	const [copied, setCopied] = useState(false);

	const displayName = providerId ? `${providerId}/${modelName}` : modelName;

	const copyToClipboard = async () => {
		try {
			await navigator.clipboard.writeText(displayName);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (err) {
			console.error("Failed to copy:", err);
		}
	};

	return (
		<div className="flex items-center gap-2">
			<code className="bg-muted px-2 py-1 rounded text-sm font-mono">
				{displayName}
			</code>
			<Button
				variant="ghost"
				size="sm"
				onClick={copyToClipboard}
				className="h-6 w-6 p-0"
				aria-label={t("public.common.copyModelId")}
			>
				{copied ? (
					<Check className="h-3 w-3 text-green-600" />
				) : (
					<Copy className="h-3 w-3" />
				)}
			</Button>
		</div>
	);
}
